module.exports = __webpack_public_path__ + "static/login_img-1d4895e20b49a2d8a681acd2e73c3c4e.png";